
export default {
    setSpidLevel(context, spidLevel) {
        context.commit('setSpidLevel', spidLevel);
    },
    setSpName(context, spName) {
        context.commit('setSpName', spName);
    },
    setProfile(context, profile) {
        context.commit('setProfile', profile);
    }
}
